<template>
  <v-row class="fill-height" fluid>
    <v-container fluid>
      <v-subheader class="mb-5">
        <h1>Configuración de Sistema</h1>
      </v-subheader>
      <v-row>
        <v-col cols="12" md="12">
          <v-container>
            <v-subheader>Parámetros</v-subheader>
            <v-data-table
              :headers="parametros.headers"
              :items="parametros.items"
              :loading="parametros.loading"
              class="elevation-1"
              dense
              item-key="codigo"
            >
              <template v-slot:item.acciones="{ item }">
                <v-icon
                  v-if="vista.escritura"
                  medium
                  class="mr-2"
                  @click.stop="editarParametro(item, true)"
                  >mdi-pencil</v-icon
                >
              </template>
            </v-data-table>
            <v-dialog
              v-model="parametros.dialogo.open"
              persistent
              max-width="600px"
            >
              <v-card>
                <v-card-title>
                  <span class="headline">{{ parametros.dialogo.titulo }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          dense
                          v-model="parametros.dialogo.codigo"
                          label="Nombre"
                          @input="
                            v => {
                              parametros.dialogo.codigo = v.toUpperCase();
                            }
                          "
                          @keyup.enter="guardarParametro()"
                          required
                          :disabled="
                            !parametros.dialogo.nuevo ||
                              parametros.dialogo.loading
                          "
                          placeholder="Nombre"
                          outlined
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="8">
                        <v-text-field
                          dense
                          v-model="parametros.dialogo.descripcion"
                          label="Descripción"
                          @keyup.enter="guardarParametro()"
                          :disabled="
                            !parametros.dialogo.nuevo ||
                              parametros.dialogo.loading
                          "
                          placeholder="Descripción"
                          outlined
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          dense
                          v-model="parametros.dialogo.valor"
                          label="Valor"
                          @keyup.enter="guardarParametro()"
                          :disabled="
                            !parametros.dialogo.edicion ||
                              parametros.dialogo.loading
                          "
                          placeholder="Valor"
                          outlined
                          hide-details
                          :type="tipoInput"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          dense
                          v-model="parametros.dialogo.unidades"
                          label="Unidades"
                          @keyup.enter="guardarParametro()"
                          :disabled="
                            !parametros.dialogo.edicion ||
                              parametros.dialogo.loading
                          "
                          placeholder="Unidades"
                          outlined
                          hide-details
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click.stop="cerrarParametro()"
                    :disabled="parametros.dialogo.loading"
                    >Cerrar</v-btn
                  >
                  <v-btn
                    v-if="parametros.dialogo.edicion"
                    color="blue darken-1"
                    text
                    @click.stop="guardarParametro()"
                    :disabled="parametros.dialogo.loading"
                    >Guardar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-container>
          <v-container>
            <v-subheader>Tipos de mantenimiento</v-subheader>
            <v-row>
              <v-col cols="12" sm="12" md="8" lg="5">
                <v-data-table
                  dense
                  :headers="mantenimientos.headers"
                  :items="mantenimientos.items"
                  :loading="mantenimientos.loading"
                  class="elevation-1"
                  item-key="codigo"
                  disable-pagination
                  hide-default-footer
                >
                  <template v-slot:item.acciones="{ item }">
                    <!-- <v-icon
                      v-if="vista.lectura"
                      medium
                      class="mr-2"
                      @click.stop="editarMant(item, false)"
                    >
                      mdi-eye
                    </v-icon> -->
                    <v-icon
                      v-if="vista.escritura"
                      medium
                      class="mr-2"
                      @click.stop="editarMant(item, true)"
                    >
                      mdi-pencil
                    </v-icon>
                  </template>
                  <template v-slot:item.intervalo="{ item }">
                    <span
                      class="d-inline-flex justify-center"
                      style="width: 100%;"
                    >
                      {{ item.intervalo }}
                    </span>
                  </template>
                  <!-- <template v-slot:item.intervalo="{ item }">
                    <div class="d-inline-flex justify-center">
                      <v-text-field
                        :disabled="!vista.escritura || mantenimientos.loading"
                        class="contador mr-1 ml-1 mb-1 align-self-center"
                        dense
                        hide-details
                        style="width: 40px;"
                        type="number"
                        v-model="item.intervalo"
                      ></v-text-field>
                    </div>
                  </template> -->
                </v-data-table>
              </v-col>
            </v-row>
            <v-dialog
              v-model="mantenimientos.dialogo.open"
              persistent
              max-width="500px"
            >
              <v-card>
                <v-card-title>
                  <span class="headline">{{
                    mantenimientos.dialogo.titulo
                  }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="4" lg="3">
                        <v-text-field
                          dense
                          v-model="mantenimientos.dialogo.codigo"
                          label="Código"
                          @input="
                            v => {
                              mantenimientos.dialogo.codigo = v.toUpperCase();
                            }
                          "
                          required
                          disabled
                          placeholder="Código"
                          outlined
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="8" lg="9">
                        <v-text-field
                          dense
                          v-model="mantenimientos.dialogo.descripcion"
                          label="Descripción"
                          disabled
                          placeholder="Descripción"
                          outlined
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <v-text-field
                          dense
                          v-model="mantenimientos.dialogo.intervalo"
                          label="Minutos Intervalo cita"
                          @keyup.enter="guardarMant()"
                          :disabled="
                            !mantenimientos.dialogo.edicion ||
                              mantenimientos.dialogo.loading
                          "
                          placeholder="Minutos Intervalo cita"
                          outlined
                          hide-details
                          type="number"
                          @input="
                            v => {
                              mantenimientos.dialogo.intervalo = numero(v);
                            }
                          "
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click.stop="cerrarMant()"
                    :disabled="mantenimientos.dialogo.loading"
                    >Cerrar</v-btn
                  >
                  <v-btn
                    v-if="mantenimientos.dialogo.edicion"
                    color="blue darken-1"
                    text
                    @click.stop="guardarMant()"
                    :disabled="mantenimientos.dialogo.loading"
                    >Guardar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-container>
          <v-container>
            <v-subheader>Rangos de atención</v-subheader>
            <v-row style="margin-top: 20px;">
              <v-col cols="12" sm="1" md="2" lg="1" class="pa-1">
                <label
                  class="align-self-center mr-5 d-sm-none d-md-block d-lg-block"
                  style="text-align: right;"
                  >Lunes</label
                >
                <label
                  class="align-self-center mr-5 d-md-none d-lg-none d-sm-block"
                  style="text-align: right;"
                  >L</label
                >
              </v-col>
              <v-col cols="12" sm="11" md="9" lg="10">
                <v-range-slider
                  :min="0"
                  :max="23"
                  class="align-center"
                  hide-details
                  thumb-label="always"
                  v-model="rangos[0]"
                  @end="guardarRango(0, rangos[0][0], rangos[0][1])"
                ></v-range-slider>
              </v-col>
            </v-row>
            <v-row style="margin-top: 20px;">
              <v-col cols="12" sm="1" md="2" lg="1" class="pa-1">
                <label
                  class="align-self-center mr-5 d-sm-none d-md-block d-lg-block"
                  style="text-align: right;"
                  >Martes</label
                >
                <label
                  class="align-self-center mr-5 d-md-none d-lg-none d-sm-block"
                  style="text-align: right;"
                  >Ma</label
                >
              </v-col>
              <v-col cols="12" sm="11" md="9" lg="10">
                <v-range-slider
                  :min="0"
                  :max="23"
                  class="align-center"
                  hide-details
                  thumb-label="always"
                  v-model="rangos[1]"
                  @end="guardarRango(1, rangos[1][0], rangos[1][1])"
                ></v-range-slider>
              </v-col>
            </v-row>
            <v-row style="margin-top: 20px;">
              <v-col cols="12" sm="1" md="2" lg="1" class="pa-1">
                <label
                  class="align-self-center mr-5 d-sm-none d-md-block d-lg-block"
                  style="text-align: right;"
                  >Miércoles</label
                >
                <label
                  class="align-self-center mr-5 d-md-none d-lg-none d-sm-block"
                  style="text-align: right;"
                  >Mi</label
                >
              </v-col>
              <v-col cols="12" sm="11" md="9" lg="10">
                <v-range-slider
                  :min="0"
                  :max="23"
                  class="align-center"
                  hide-details
                  thumb-label="always"
                  v-model="rangos[2]"
                  @end="guardarRango(2, rangos[2][0], rangos[2][1])"
                ></v-range-slider>
              </v-col>
            </v-row>
            <v-row style="margin-top: 20px;">
              <v-col cols="12" sm="1" md="2" lg="1" class="pa-1">
                <label
                  class="align-self-center mr-5 d-sm-none d-md-block d-lg-block"
                  style="text-align: right;"
                  >Jueves</label
                >
                <label
                  class="align-self-center mr-5 d-md-none d-lg-none d-sm-block"
                  style="text-align: right;"
                  >J</label
                >
              </v-col>
              <v-col cols="12" sm="11" md="9" lg="10">
                <v-range-slider
                  :min="0"
                  :max="23"
                  class="align-center"
                  hide-details
                  thumb-label="always"
                  v-model="rangos[3]"
                  @end="guardarRango(3, rangos[3][0], rangos[3][1])"
                ></v-range-slider>
              </v-col>
            </v-row>
            <v-row style="margin-top: 20px;">
              <v-col cols="12" sm="1" md="2" lg="1" class="pa-1">
                <label
                  class="align-self-center mr-5 d-sm-none d-md-block d-lg-block"
                  style="text-align: right;"
                  >Viernes</label
                >
                <label
                  class="align-self-center mr-5 d-md-none d-lg-none d-sm-block"
                  style="text-align: right;"
                  >V</label
                >
              </v-col>
              <v-col cols="12" sm="11" md="9" lg="10">
                <v-range-slider
                  :min="0"
                  :max="23"
                  class="align-center"
                  hide-details
                  thumb-label="always"
                  v-model="rangos[4]"
                  @end="guardarRango(4, rangos[4][0], rangos[4][1])"
                ></v-range-slider>
              </v-col>
            </v-row>
            <v-row style="margin-top: 20px;">
              <v-col cols="12" sm="1" md="2" lg="1" class="pa-1">
                <label
                  class="align-self-center mr-5 d-sm-none d-md-block d-lg-block"
                  style="text-align: right;"
                  >Sábado</label
                >
                <label
                  class="align-self-center mr-5 d-md-none d-lg-none d-sm-block"
                  style="text-align: right;"
                  >S</label
                >
              </v-col>
              <v-col cols="12" sm="11" md="9" lg="10">
                <v-range-slider
                  :min="0"
                  :max="23"
                  class="align-center"
                  hide-details
                  thumb-label="always"
                  v-model="rangos[5]"
                  @end="guardarRango(5, rangos[5][0], rangos[5][1])"
                ></v-range-slider>
              </v-col>
            </v-row>
            <v-row style="margin-top: 20px;">
              <v-col cols="12" sm="1" md="2" lg="1" class="pa-1">
                <label
                  class="align-self-center mr-5 d-sm-none d-md-block d-lg-block"
                  style="text-align: right;"
                  >Domingo</label
                >
                <label
                  class="align-self-center mr-5 d-md-none d-lg-none d-sm-block"
                  style="text-align: right;"
                  >D</label
                >
              </v-col>
              <v-col cols="12" sm="11" md="9" lg="10">
                <v-range-slider
                  :min="0"
                  :max="23"
                  class="align-center"
                  hide-details
                  thumb-label="always"
                  v-model="rangos[6]"
                  @end="guardarRango(6, rangos[6][0], rangos[6][1])"
                ></v-range-slider>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
export default {
  name: "Configuracion",
  data: () => ({
    vista: {},
    parametros: {
      loading: false,
      headers: [
        {
          text: "#",
          align: "start",
          sortable: false,
          value: "correlativo"
        },
        { text: "Nombre", value: "codigo" },
        { text: "Descripción", value: "descripcion" },
        { text: "Valor", value: "valor" },
        { text: "Unidades", value: "unidades" },
        { text: "Acciones", value: "acciones", sortable: false }
      ],
      items: [],
      dialogo: {
        nuevo: false,
        edicion: false,
        loading: false,
        open: false,
        codigo: "",
        descripcion: "",
        valor: "",
        unidades: "",
        tipo: ""
      }
    },
    mantenimientos: {
      loading: false,
      headers: [],
      items: [],
      dialogo: {
        nuevo: false,
        edicion: false,
        loading: false,
        open: false,
        codigo: "",
        descripcion: "",
        intervalo: 0
      }
    },
    rangos: [
      [0, 23], //lunes
      [0, 23], //martes
      [0, 23], //miércoles
      [0, 23], //jueves
      [0, 23], //viernes
      [0, 23], //sábado
      [0, 23] //domingo
    ]
  }),
  computed: {
    ...mapGetters(["getToken", "getRol"]),
    tipoInput() {
      switch (this.parametros.dialogo.tipo) {
        case "PASSWORD":
          return "password";
        case "NUMERO":
          return "number";
        default:
          return "text";
      }
    }
  },
  methods: {
    ...mapActions(["setToken", "showAlerta2", "hideAlerta2"]),
    numero(valor) {
      let numero = parseFloat(valor);

      if (
        isNaN(numero) ||
        numero < 1 ||
        numero == null ||
        numero == undefined
      ) {
        numero = 1;
      }

      return numero;
    },
    async loadVista() {
      let respuesta;
      try {
        respuesta = await axios.get(
          process.env.VUE_APP_BASE_PATH +
            `/api/usuario/ObtenerVista?vista=ADMINISTRACION.CONFIGURACION`,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      }
      // console.log(respuesta.data);
      this.vista = respuesta.data;
    },
    async listarParametros() {
      let respuesta;
      try {
        this.parametros.loading = true;
        respuesta = await axios.get(
          process.env.VUE_APP_BASE_PATH + "/api/config/listarParametros",
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }

        return;
      } finally {
        this.parametros.loading = false;
      }

      this.parametros.items = respuesta.data.map((el, idx) => {
        return {
          ...el,
          correlativo: idx + 1,
          acciones: null
        };
      });
    },
    async listarMantenimientos() {
      let respuesta;
      try {
        this.mantenimientos.loading = true;
        respuesta = await axios.get(
          process.env.VUE_APP_BASE_PATH + "/api/config/ListarTiposMant",
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }

        return;
      } finally {
        this.mantenimientos.loading = false;
      }

      this.mantenimientos.items = respuesta.data.map((el, idx) => {
        return {
          ...el,
          correlativo: idx + 1,
          acciones: null
        };
      });
    },
    async loadRangos() {
      let respuesta;
      try {
        respuesta = await axios.get(
          process.env.VUE_APP_BASE_PATH + "/api/config/ListarRangosAtencion",
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }

        return;
      }

      let data = Array.isArray(respuesta.data) ? respuesta.data : [];
      this.rangos = data
        .sort((a, b) => a.dia - b.dia)
        .map(x => [x.hora_inicio, x.hora_fin]);
    },
    async guardarRango(dia, inicio, fin) {
      const params = {
        dia: dia,
        hora_inicio: inicio,
        hora_fin: fin
      };
      let respuesta;
      try {
        respuesta = await axios.post(
          process.env.VUE_APP_BASE_PATH + "/api/config/GuardarRango",
          params,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      }
      console.log(respuesta.data);
    },
    nuevoMant() {
      this.mantenimientos.dialogo.nuevo = true;
      this.mantenimientos.dialogo.edicion = true;
      this.mantenimientos.dialogo.titulo = "Nuevo de Tipo de Mantenimiento";
      this.mantenimientos.dialogo.codigo = "";
      this.mantenimientos.dialogo.descripcion = "";
      this.mantenimientos.dialogo.intervalo = 0;
      this.mantenimientos.dialogo.open = true;
    },
    editarParametro(item, edicion) {
      this.parametros.dialogo.nuevo = false;
      this.parametros.dialogo.edicion = edicion;
      this.parametros.dialogo.titulo =
        (edicion ? "Edición" : "Consulta") + " de Parámetro";
      this.parametros.dialogo.codigo = item.codigo;
      this.parametros.dialogo.descripcion = item.descripcion;
      if (item.tipo == "PASSWORD") {
        this.parametros.dialogo.valor = "";
      } else {
        this.parametros.dialogo.valor = item.valor;
      }
      this.parametros.dialogo.unidades = item.unidades;
      this.parametros.dialogo.tipo = item.tipo;
      this.parametros.dialogo.open = true;
    },
    editarMant(item, edicion) {
      this.mantenimientos.dialogo.nuevo = false;
      this.mantenimientos.dialogo.edicion = edicion;
      this.mantenimientos.dialogo.titulo =
        (edicion ? "Edición" : "Consulta") + " de Tipo de Mantenimiento";
      this.mantenimientos.dialogo.codigo = item.codigo;
      this.mantenimientos.dialogo.descripcion = item.descripcion;
      this.mantenimientos.dialogo.intervalo = item.intervalo;
      this.mantenimientos.dialogo.open = true;
    },
    async eliminarMant(item) {
      const params = {
        codigo: item.codigo
      };
      let respuesta;
      try {
        respuesta = await axios.post(
          process.env.VUE_APP_BASE_PATH + "/api/config/EliminarTipoMant",
          params,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      }
      this.listarMantenimientos();
      this.showAlerta2({
        mensaje: respuesta.data.mensaje,
        tipo: respuesta.data.tipo
      });
    },
    async guardarParametro() {
      const params = {
        nuevo: this.parametros.dialogo.nuevo,
        codigo: this.parametros.dialogo.codigo,
        descripcion: this.parametros.dialogo.descripcion,
        tipo: this.parametros.dialogo.tipo,
        valor: this.parametros.dialogo.valor,
        unidades: this.parametros.dialogo.unidades
      };

      let respuesta;
      try {
        this.parametros.dialogo.loading = true;
        respuesta = await axios.post(
          process.env.VUE_APP_BASE_PATH + "/api/config/GuardarParametro",
          params,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      } finally {
        this.parametros.dialogo.loading = false;
      }

      this.listarParametros();

      this.showAlerta2({
        mensaje: respuesta.data.mensaje,
        tipo: respuesta.data.tipo
      });

      if (respuesta.data.tipo == 0) {
        this.parametros.dialogo.open = false;
      }
    },
    async guardarMant() {
      const params = {
        nuevo: this.mantenimientos.dialogo.nuevo,
        codigo: this.mantenimientos.dialogo.codigo,
        intervalo: this.mantenimientos.dialogo.intervalo,
        descripcion: this.mantenimientos.dialogo.descripcion
      };

      let respuesta;
      try {
        this.mantenimientos.dialogo.loading = true;
        respuesta = await axios.post(
          process.env.VUE_APP_BASE_PATH + "/api/config/GuardarTipoMant",
          params,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      } finally {
        this.mantenimientos.dialogo.loading = false;
      }

      this.listarMantenimientos();

      this.showAlerta2({
        mensaje: respuesta.data.mensaje,
        tipo: respuesta.data.tipo
      });

      if (respuesta.data.tipo == 0) {
        this.mantenimientos.dialogo.open = false;
      }
    },
    cerrarParametro() {
      this.parametros.dialogo.open = false;
      this.parametros.dialogo.codigo = "";
      this.parametros.dialogo.descripcion = "";
      this.parametros.dialogo.valor = "";
      this.parametros.dialogo.unidades = "";
    },
    cerrarMant() {
      this.mantenimientos.dialogo.open = false;
      this.mantenimientos.dialogo.codigo = "";
      this.mantenimientos.dialogo.descripcion = "";
    },
    salir() {
      this.setToken("");
      this.$router.push({ path: "/Login" });
    }
  },
  async created() {
    await this.loadVista();

    let headers = [
      {
        text: "#",
        align: "start",
        sortable: false,
        value: "correlativo"
      },
      { text: "Código", value: "codigo" },
      { text: "Descripción", value: "descripcion" },
      { text: "Intervalo cita", value: "intervalo", sortable: false }
    ];

    if (this.vista.escritura) {
      headers.push({ text: "Acciones", value: "acciones", sortable: false });
    }

    this.mantenimientos.headers = headers;

    this.listarParametros();
    this.listarMantenimientos();
    this.loadRangos();
  }
};
</script>

<style scoped>
</style>
